var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{class:_vm.indicatorClass},[_vm._v(_vm._s(_vm.value.length))]),(_vm.maxChars)?_c('span',[_vm._v(" / "+_vm._s(_vm.maxChars))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }